import { type TileIndex, type TileNeighbour } from "@/types/tile";
import { formatPercent } from "@/utils/format";
import { FrameName } from "../config";
import { ResourceType } from "../config/resources";
import TileEntity from "../TileEntity";

class TollHouseBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.TOLL_HOUSE;

	public get description(): string {
		return super.description.replace(
			"{percent}",
			formatPercent(
				(this.config.production.get(
					ResourceType.PRODUCTION_ONCLICK_RESOURCE_MULTIPLIER,
				)! as number) - 1,
			),
		);
	}

	public get canUpgradeTo(): Set<FrameName> {
		if (this.cachedCanUpgradeTo) return this.cachedCanUpgradeTo;

		const upgrades = new Set<FrameName>([...super.canUpgradeTo]);
		if (!this.upgrades.size) return (this.cachedCanUpgradeTo = upgrades);

		const neighbours = this.tilerepo
			.getNeighbourTileIndexesByTileCoordinates(
				{ x: this.x, y: this.y },
				2,
				true,
			)
			.map((tileIndex: TileIndex): TileNeighbour | null => {
				const [, , tileId] =
					this.tilerepo.getTileIdsByTileIndex(tileIndex);
				if (!tileId) return null;

				const frameName = this.tilerepo.getFrameNameByTileId(tileId);
				if (!frameName) return null;

				return {
					tileIndex,
					tileId,
					frameName,
				};
			})
			.filter(
				(neighbour: TileNeighbour | null): boolean =>
					neighbour !== null,
			) as Array<TileNeighbour>;

		if (neighbours.length === 0)
			return (this.cachedCanUpgradeTo = upgrades);

		if (
			neighbours.find(
				({ frameName }): boolean => frameName === FrameName.TAX_OFFICE,
			)
		)
			upgrades.delete(FrameName.TAX_OFFICE);

		return (this.cachedCanUpgradeTo = upgrades);
	}
}

export default TollHouseBuildingTileEntity;
